<template>
  <div class="cbg-auth-restore">
    <p class="cbg-auth-restore__title">{{restoreTitle}}</p>
    <p v-if="step === 1" class="cbg-auth-restore__description">Tell us your email address and we’ll help you to sign in.</p>
    <form class="cbg-auth-form" @submit.prevent="handleSubmit">
      <Input ref="emailInput" v-if="step === 1" v-model="email" class-name="cbg-auth-restore__input" input-name="Email" :is-required="true" validation-type="email" :is-wrong="isEmailWrong"/>
      <div v-else class="cbg-auth-restore__password">
        <PasswordInput ref="passwordInput" class-name="cbg-auth-restore__input" v-model="password" input-name="Password" :is-new="true"/>
        <PasswordInput ref="confirmInput" class-name="cbg-auth-restore__input" v-model="confirmPassword" input-name="Confirm password" :confirm-password="password" />
      </div>
      <div v-if="step === 1" class="cbg-auth-restore__buttons">
        <button class="cbg-auth-restore__buttons-item" :disabled="isDisabled || isLoading" type="submit">
          <span>Continue</span>
          <span v-if="isLoading" class="spinner"></span>
        </button>
        <button class="cbg-auth-restore__buttons-item cbg-auth-restore__buttons-item_bordered" type="button"  @click="cancelRestore">Cancel</button>
      </div>
      <button v-else class="cbg-auth-restore__button" :disabled="isDisabled || isLoading" type="submit">
        <span class="cbg-auth-restore__button-text">Done</span>
        <Svg v-if="!isLoading" class-name="cbg-auth-restore__button-ico" icon-id="#ok"/>
        <span v-else class="spinner"></span>
      </button>
    </form>
  </div>
</template>

<script>
import Input from "@/components/elements/Input.vue";
import Svg from "@/components/global/Svg.vue";
import {formValidation} from "@/mixins/formValidation";
import PasswordInput from "@/components/elements/PasswordInput.vue";
import {sendRequests} from "@/mixins/sendRequests";
import {requestValidation} from "@/mixins/requestValidation";
export default {
  name: 'AuthRestore',
  components: {
    PasswordInput,
    Svg,
    Input
  },
  mixins: [requestValidation, formValidation, sendRequests],
  data() {
    return {
      email: '',
      password: '',
      confirmPassword: '',
    };
  },
  computed: {
    restoreTitle() {
      return this.step === 1 ? 'Find your account' : 'Enter new password';
    },
    step() {
      return this.context ? this.context.step : null;
    },
  },
  methods: {
    updateStep(value) {
      this.isValidAll();

      if (this.updateContext && !this.isDisabled) {
        this.updateContext('email', this.email);
        this.updateContext('step', value);
      }
    },

    cancelRestore() {
      this.updateContext && this.updateContext('step', 0);
    },

    continueHandler() {
      this.isValidAll();

      if (!this.isDisabled) {
        this.updateContext && this.updateContext('email', this.email);
        this.resetPasswordRequest(this.email);
      }
    },

    handleSetPassword() {
      this.isValidAll();

      if (!this.isDisabled) {
        this.newPasswordRequest();
      }
    },

    handleSubmit() {
      this.step === 1 ? this.continueHandler() : this.handleSetPassword();
    }
  },
}
</script>